import { CalendarCellProps } from "common/components/CalendarPro";
import { BoatItem } from "features/boats/boatApi";
import { useMemo } from "react";
import { CalendarEventItem } from "../../eventApi";

//export const CALENDAR_MONTH_CELL_WIDTH = "14.2857143%";
export const CALENDAR_MONTH_CELL_WIDTH = "14.25%";

export type StartGroup = {
  key: string;
  number_of_guests: number;
  number_of_places: number;
  duration: number;
  start_time: string;
  boats: BoatGroup[];
};

export type BoatGroup = {
  key: string;
  boat: BoatItem;
  events: CalendarEventItem[];
};

export interface BoatStartCellProps
  extends CalendarCellProps<CalendarEventItem> {}
export default function useCell(props: BoatStartCellProps) {
  return useMemo(() => {
    let result: { [key: string]: BoatGroup } = {};
    props.events.forEach(item => {
      const boatKey = `${item.boat_id}-${item.event_group_id}`;

      if (!result[boatKey]) {
        result[boatKey] = {
          key: boatKey,
          boat: item.boat,
          events: [],
          number_of_guests: 0,
          number_of_places: 0,
        } as BoatGroup;
      }

      result[boatKey].events.push(item);
    });

    // Sort events within each BoatGroup by event.program.sort_by
    Object.values(result).forEach(group => {
      group.events.sort((a, b) => a.program.sort_by - b.program.sort_by);
    });

    const _startTimes = Object.values(result);
    _startTimes.sort((a, b) => a.boat?.sort_by - b.boat?.sort_by);
    return { startTimes: _startTimes };
  }, [props.events]);
}
